import Number from "./../numberComponent/number.vue";
import utils from "@/utils.js";
import { createNamespacedHelpers } from "vuex";
import { serviceTimeRangeToString } from "@/utils";

const { mapGetters: userGetters } = createNamespacedHelpers("user"),
	{ mapGetters: brandingGetters } = createNamespacedHelpers("branding");

export default {
	name: "ItemTable",
	props: {
		activeSort: {
			// true - sort by cost, false - sort by weight
			type: Boolean,
			default: false,
		},
		activeVisual: {
			type: String,
			default: "serviceTime",
		},
		itemsData: {
			type: Array,
			required: true,
			default: () => [],
		},
		pathName: {
			type: String,
			default: () => "",
		},
		itemCount: {},
		indexedTable: {
			type: Boolean,
			default: false,
		},
		colorPrefix: {
			type: Boolean,
			default: false,
		},
		showPercentage: {
			type: Boolean,
			default: true,
		},
		actionTable: {
			type: Boolean,
			default: false,
		},
		colors: {
			type: [Object, Array],
			default: () => [],
		},
		legend: {
			type: [Object, Array],
			default: () => [],
		},
		wasteSourceWithTranslations: {
			type: [Object, Array],
			required: false,
		},
		hideHeader: Boolean,
		grToKg: {
			type: Boolean,
			default: false,
		},
		closeAccordions: {
			type: Boolean,
			default: false,
		},
		showLess: {
			type: Boolean,
			default: false,
		},
	},
	components: { Number },
	data() {
		return {
			activeItem: null,
			utils: utils,
		};
	},

	computed: {
		itemsDataIndex() {
			return this.itemCount === undefined ? this.itemsData.length : this.itemCount;
		},

		...userGetters(["activeOutlet", "weightUnit", "serviceTimeSets"]),
		...brandingGetters(["serviceTimesColors", "sourceWasteColors"]),
	},

	methods: {
		setActiveItem,
		mapData,
		closeAllAccordions,
		getItemMinWidth,
		handleItemImageClick,
	},
	watch: {
		closeAccordions: function () {
			this.closeAllAccordions();
		},
	},
};

function closeAllAccordions() {
	if (this.closeAccordions) this.activeItem = null;
}

function setActiveItem(item, index) {
	this.activeItem = index === this.activeItem ? null : index;
	this.activeItem === null ? "" : this.$emit("active-item", item);
}

function mapData(item) {
	if (this.activeVisual === "serviceTime") {
		const res = [];
		Object.keys(item.st_values).forEach((sts, stsN) => {
			const stsData = [];
			const numSTs = this.serviceTimeSets[sts].st_labels.length + 1; // +1 for ST X
			// values for all service times exc. ST X
			this.serviceTimeSets[sts].st_labels.forEach((stsLabel, index) => {
				const value = item.st_values[sts].weight_percentage[index];
				const stTime = this.serviceTimeSets[sts].st_times[index];
				if (value > 0) {
					stsData.push({
						value,
						opacity: `${((numSTs - index - 1) * 100) / numSTs}%`, // eslint-disable-line no-magic-numbers
						title: `${Math.round(value)}% - ${stsLabel} - ${serviceTimeRangeToString(stTime)}`,
					});
				}
			});

			// ST X
			const value = item.st_values[sts].weight_percentage[5];
			if (value > 0) {
				stsData.push({
					value,
					opacity: 0,
					title: `${Math.round(value)}% - ${this.$t("service_times.out_of_service_time")}`,
				});
			}

			const bgColor = this.serviceTimesColors[stsN],
				split1 = Math.sqrt(2) * 1.5, // eslint-disable-line no-magic-numbers
				split2 = Math.sqrt(2) * 4.5, // eslint-disable-line no-magic-numbers
				isStandard = this.serviceTimeSets[sts].data.name === "Standard",
				hasGradient = isStandard && Object.keys(item.st_values).length > 1;
			res.push({
				sts,
				background: hasGradient
					? `repeating-linear-gradient(135deg, transparent, transparent ${split1}px, ${bgColor} ${split1}px, ${bgColor} ${split2}px)`
					: bgColor,
				stsName: this.serviceTimeSets[sts].data.name,
				stsData,
			});
		});
		return res;
	}
	// "source"
	const arr = [];
	for (const element of this.wasteSourceWithTranslations) {
		Object.keys(item.source_values).forEach((key) => {
			if (element.id === parseInt(key)) {
				const value = Math.round(item.source_values[key].weight);
				if (value > 0) {
					arr.push({
						value,
						color: this.sourceWasteColors[element.source_name.toLowerCase()],
					});
				}
			}
		});
	}

	return arr;
}

function getItemMinWidth(value) {
	const MIN_VALUE = 0;

	if (value > MIN_VALUE) {
		const valueLength = value.toString().split(""),
			MIN_LENGTH = 1,
			WIDTH = 5;

		return valueLength.length === MIN_LENGTH ? WIDTH : "";
	}
}

function handleItemImageClick(item) {
	this.$ma.trackEvent({
		action: "Category Click",
		properties: {
			Value: item.item_name,
			Component: this.$route.name,
		},
	});

	this.$eventBus.$emit("loadItemTrashEvents", { label_id: item.id });
}
